import React from "react"
import ChrWidgetLoader from "./ChrWidgetLoader"

const ChrWidgetLoaders = (props) => {
  const { rows=1, columns=1, containerClassName='white-bg', additionalClassNames='' } = props;

  return (
    <div className={ containerClassName }>
      { [...Array(rows)].map((_, index) => <ChrWidgetLoader key={ index } loadersCount={ columns } additionalClassNames={ additionalClassNames } />) }
    </div>
  )
}

export default ChrWidgetLoaders;